/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Locale_DefaultInputs */

const en_error_email_locale_default = /** @type {(inputs: Error_Email_Locale_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The default language of an email cannot be removed.`)
};

/**
* | output |
* | --- |
* | "The default language of an email cannot be removed." |
*
* @param {Error_Email_Locale_DefaultInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_email_locale_default = /** @type {((inputs?: Error_Email_Locale_DefaultInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Locale_DefaultInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_email_locale_default(inputs)
});